export default "__VITE_ASSET__154bd115__"